import { html } from "lit-html";
import { DynamicSettings } from "./DynamicSettings";
import { useSaveDynamicSettings } from "./useSaveDynamicSettings";

export interface Props {
	newSettings: DynamicSettings;
	setNewSettings: (settings: DynamicSettings) => void;
}

type DefaultPromoCodes = Pick<
	DynamicSettings,
	| "DefaultPromotionCodeAr"
	| "DefaultPromotionCodeBr"
	| "DefaultPromotionCodeCl"
	| "DefaultPromotionCodeCo"
	| "DefaultPromotionCodeDo"
	| "DefaultPromotionCodeEc"
	| "DefaultPromotionCodeGb"
	| "DefaultPromotionCodePe"
	| "DefaultPromotionCodePy"
	| "DefaultPromotionCodeUs"
	| "DefaultPromotionCodeUy"
>;

export const useDefaultPromoCodeSection = (props: Props) => {
	const saver = useSaveDynamicSettings({ newSettings: props.newSettings });

	const inputTemplate = (data: { label: string; key: keyof DefaultPromoCodes }) => html`
		<ac-input
			.label=${data.label}
			.value=${props.newSettings[data.key]}
			.onInput=${(value: string) => props.setNewSettings({ ...props.newSettings, [data.key]: value })}
		></ac-input>
	`;

	const htmlTemplate = () => html`
		<section class="mt-5 max-w-[640px]">
			<div class="grid grid-cols-2 gap-4">
				${inputTemplate({ label: "Default Navitaire Promo Code CL", key: "DefaultPromotionCodeCl" })}
				${inputTemplate({ label: "Default Navitaire Promo Code AR", key: "DefaultPromotionCodeAr" })}
				${inputTemplate({ label: "Default Navitaire Promo Code BR", key: "DefaultPromotionCodeBr" })}
				${inputTemplate({ label: "Default Navitaire Promo Code CO", key: "DefaultPromotionCodeCo" })}
				${inputTemplate({ label: "Default Navitaire Promo Code EC", key: "DefaultPromotionCodeEc" })}
				${inputTemplate({ label: "Default Navitaire Promo Code PY", key: "DefaultPromotionCodePy" })}
				${inputTemplate({ label: "Default Navitaire Promo Code PE", key: "DefaultPromotionCodePe" })}
				${inputTemplate({ label: "Default Navitaire Promo Code UY", key: "DefaultPromotionCodeUy" })}
				${inputTemplate({ label: "Default Navitaire Promo Code US", key: "DefaultPromotionCodeUs" })}
				${inputTemplate({ label: "Default Navitaire Promo Code DO", key: "DefaultPromotionCodeDo" })}
				${inputTemplate({ label: "Default Navitaire Promo Code GB", key: "DefaultPromotionCodeGb" })}
			</div>
			${saver.htmlTemplate()}
		</section>
	`;

	return { htmlTemplate };
};
